import {LoggerService} from "./domain/logger.service.js";
import {PlaceholderService} from "./domain/placeholder.service.js";
import {BadgeService} from "./domain/badge.service.js";
import {Api2Service} from "./domain/api2.service.js";
import {I18nService} from "./domain/i18n.service.js";
import {UrlService} from "./domain/url.service.js";
import {HttpService} from "./domain/http.service.js";
import {ResponsivenessService} from "./domain/responsiveness.service.js";
import {MetadataService} from "./domain/metadata.service.js";
import { FeatureService } from "./domain/feature.service.js";
import { BadgeCompositionService } from './domain/badge-composition.service.js';
import { GlobalService } from './domain/global.service.js';
import { appContext } from './badge2.context.js';
import { DomDetector } from './utils/dom-detector.js';
import { JournalService } from './domain/journal.service.js';
import { CssService } from "./domain/css.service";
import { ExternalControlService } from "./domain/external-control.service";
import { ScrapingService } from "./domain/scraping.service";

let loaded = false;

/**
 * Registers service instances in our container, for badge app usage
 * @returns {void}
 */
export const loadContext = () => {
  if (loaded) {
    return;
  }

  appContext.register(ExternalControlService, new ExternalControlService());
  appContext.register(GlobalService, new GlobalService());
  appContext.register(JournalService, new JournalService());
  appContext.register(LoggerService, new LoggerService('badge2'));
  appContext.register(CssService, new CssService());
  appContext.register(ScrapingService, new ScrapingService());
  appContext.register(MetadataService, new MetadataService());
  appContext.register(PlaceholderService, new PlaceholderService());
  appContext.register(ResponsivenessService, new ResponsivenessService());
  appContext.register(BadgeService, new BadgeService());
  appContext.register(BadgeCompositionService, new BadgeCompositionService());
  appContext.register(Api2Service, new Api2Service());
  appContext.register(I18nService, new I18nService());
  appContext.register(UrlService, new UrlService());
  appContext.register(HttpService, new HttpService());
  appContext.register(FeatureService, new FeatureService());
  appContext.register(DomDetector, new DomDetector({
    containerElement: document.body,
    checkEvents: { structureChange: true, attributeChange: null }
  })) // root DomDetector (for cross usage)

  appContext.link();

  loaded = true;
};

